<!-- 专利 -->
<template>
  <div class="container">
    <div class="banner"></div>
    <div class="main">
      <div class="content">
        <div class="Breadcrumb">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/pAF_sale' }"
              >开放许可专区</el-breadcrumb-item
            >
            <el-breadcrumb-item>详情</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="article">
          <div class="header">
            <div class="left">
              <li>
                <h2>{{ patentData.title }}</h2>
                <span>有效专利</span>
              </li>
              <li style="margin-top: 10px">
                <p>专利申请号:</p>
                <p>{{ patentData.application_number }}</p>
              </li>
            </div>
            <div class="right">
              <li @click="downloadAttachment">
                <i class="el-icon-download"></i>PDF下载
              </li>
            </div>
          </div>
          <div class="box">
            <h1>著录信息</h1>
            <ul class="change">
              <li style="margin-top: 0">
                <span>专利申请号: </span>
                <p>{{ patentData.application_number }}</p>
              </li>
              <li style="margin-top: 0">
                <span>公开(公告)号: </span>
                <p>{{ patentData.publication_number }}</p>
              </li>

              <li>
                <span>申请日: </span>
                <p>{{ formatDate(patentData.create_time) }}</p>
              </li>
              <li>
                <span>公开(公告)日: </span>
                <p>{{ patentData.publication_date }}</p>
              </li>
              <li>
                <span>申请人: </span>
                <p>{{ patentData.right_holder }}</p>
              </li>
              <li>
                <span>申请人地址: </span>
                <p>{{ patentData.applicant_address }}</p>
              </li>
              <li>
                <span>权利人: </span>
                <p>{{ patentData.right_holder }}</p>
              </li>
              <li>
                <span>主分类号: </span>
                <p>{{ patentData.main_classification }}</p>
              </li>

              <li>
                <span>当前权利人: </span>
                <p>
                  {{ patentData.current_right_holder }}
                </p>
              </li>
              <li>
                <span>IPC分类号: </span>
                <p>{{ patentData.ipc_classification }}</p>
              </li>
              <li>
                <span>代理人: </span>
                <p>{{ patentData.agent }}</p>
              </li>
              <li>
                <span>发明/设计人: </span>
                <p>{{ patentData.inventor }}</p>
              </li>
              <li>
                <span>优先权信息:</span>
                <p>{{ patentData.priority_info }}</p>
              </li>
              <li>
                <span>代理机构: </span>
                <p>{{ patentData.agency }}</p>
              </li>
            </ul>
          </div>
          <div class="box">
            <h1>摘要</h1>
            <!-- <p>
              本发明公开了一种无线传感器网络中无人机的轨迹规划方法，该方法将无线传感器网络中多无人机轨迹的设计问题模型化为混合整数非凸优化问题，该方法首先基于聚合算法对传感器节点进行分组，形成多个节点集合，并针对每一节点集合计算无人机访问该节点集合中的传感器节点的访问顺序，并针对每一访问顺序利用凸优化技术计算对应的航迹点，并利用航迹点进行计算得到中心点从而得到新的节点集合，并基于新的节点集合按照上述过程得到对应的新的航迹点，直至得到最小的访问时间为止，使得每一个无人机可以从其对应的传感器节点集合中可靠的收集数据，同时可以最小化所有无人机的飞行时间。
            </p> -->
            <div v-html="patentData.abstract" class="fuwenben"></div>
          </div>
          <div class="box status">
            <h1>法律状态</h1>
            <div v-html="patentData.legal_status" class="fuwenben"></div>
          </div>
          <div class="box">
            <h1>权利要求</h1>
            <div v-html="patentData.claims" class="fuwenben"></div>
          </div>
          <div class="box">
            <h1>说明书</h1>
            <div v-html="patentData.description" class="fuwenben"></div>
          </div>
          <div class="box" style="padding-bottom: 0">
            <h1>附图</h1>
            <!-- <img
              :src="patentData.drawings"
              alt=""
              style="width: 216px; height: 277px"
            /> -->
            <div
              style="
                display: grid;
                grid-template-columns: repeat(6, 1fr);
                gap: 10px;
              "
            >
              <!-- <div> -->
              <img
                v-for="(imgUrl, index) in drawingImages"
                :key="index"
                :src="imgUrl"
                alt="专利附图"
                style="width: 216px; height: 277px"
                @error="handleImageError"
              />
              <!-- </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPatentDetail } from "../api/userApi";
export default {
  data() {
    return {
      patentData: {},
      drawingImages: [],
    };
  },
  created() {
    this.fetchPatentDetail();
  },
  methods: {
    handleImageError(e) {
      e.target.src =
        'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="216" height="277" viewBox="0 0 216 277"><rect width="100%" height="100%" fill="#eee"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="#aaa">图片加载失败</text></svg>';
    },
    // 纯JavaScript时间格式化
    formatDate(timestamp) {
      if (!timestamp) return "";

      // 假设时间戳是秒级（如需要毫秒级则去掉*1000）
      const date = new Date(timestamp * 1000);

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },
    fetchPatentDetail() {
      console.log(this.$route.query.id, "id");

      getPatentDetail({ id: this.$route.query.id }).then((response) => {
        this.patentData = response.data;
        console.log("接口返回的数据是：", this.patentData);
        // 将逗号分隔的图片字符串拆分为数组
        if (this.patentData.drawings) {
          this.drawingImages = this.patentData.drawings.split(",");
        }
      });
    },
    async downloadAttachment() {
      const attachments = this.patentData.attachments;
      console.log(attachments, "this.patentData");

      if (!attachments) {
        this.$message.warning("暂无附件可供下载");
        return;
      }

      try {
        const response = await fetch(attachments);
        if (!response.ok) throw new Error("下载失败");

        const blob = await response.blob();
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          decodeURIComponent(attachments.split("/").pop())
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url); // 清理内存
      } catch (error) {
        console.error(error);
        // this.$message.error("下载过程中发生错误");
      }
    },
  },
};
</script>

<style scoped lang="less">
li {
  list-style: none;
}
.fuwenben {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #121212;
  text-align: left;
}
.content {
  width: 100%;
  max-width: 87.5rem;
  margin: 0 auto;
}
.banner {
  background: url(../assets/banner2.png) no-repeat center/cover;
  width: 100%;
  height: 318px;
}
.main {
  background: #f5f5f5;
  padding-bottom: 45px;
  .Breadcrumb {
    padding: 15px 0;
    ::v-deep .el-breadcrumb__inner {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #121212;
    }
  }
  .article {
    padding: 36px 10px 30px 50px;
    background: #ffffff;
    border-radius: 10px 10px 10px 10px;
    p {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #121212;
      text-align: left;
    }
    h1 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #121212;
      margin-bottom: 10px;
      text-align: left;
    }
    .box {
      border-top: 1px solid rgba(239, 237, 237, 1);
      // border-bottom: 1px solid rgba(239, 237, 237, 1);
      padding: 30px 0;
      // padding-right: 10px;
      display: flex;
      flex-direction: column;
      .change {
        width: 100%;
        flex-wrap: wrap;
        li {
          width: 45%;
          margin-right: 60px;
          margin-top: 10px;

          p {
            width: 80%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
      ul {
        display: flex;
        margin-top: 15px;
        li {
          display: flex;
          margin-right: 27px;
          align-items: center;
          span {
            color: rgba(18, 18, 18, 0.5);
            text-align: left;
          }
        }
      }
      ul:first-child {
        margin-top: 0;
      }
    }
    .status {
      ul {
        display: flex;
        flex-direction: column;
        li {
          display: flex;
          margin-right: 0;
          width: 100%;
          margin-top: 20px;
          p {
            text-align: center;
          }
          p:last-child {
            text-align: left;
          }
          .line {
            display: inline-block;
            width: 1px;
            height: 24px;
            background-color: #efeded;
            margin: 0 10px;
            vertical-align: middle;
            margin: 0 30px;
          }
        }
        li:first-child {
          margin-top: 0;
        }
      }
    }
    // .box:last-child {
    //   border-bottom: 0;
    // }
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right: 10px;
      margin-bottom: 30px;
      .left {
        li {
          display: flex;
          h2 {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 22px;
            color: #0c1223;
          }
          span {
            margin-left: 10px;
            width: 86px;
            height: 30px;
            background: #f09c57;
            border-radius: 5px 5px 5px 5px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #ffffff;
            line-height: 30px;
            text-align: center;
          }
        }
      }
      .right {
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        width: 106px;
        height: 30px;
        background: #175dc2;
        border-radius: 5px 5px 5px 5px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        i {
          margin-right: 7px;
        }
      }
    }
  }
}
</style>
